import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  display: flex;
  flex-direction: row;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 4px 8px rgba(45, 54, 67, 0.05);
  border-radius: 8px;
  padding: 16px;
  > button:not(:last-child) {
    margin-right: 16px;
  }
  > button {
    width: 135px;
  }
`;

export const ExtraButtonsContainer = styled.div`
  position: fixed;
  right: 40px;
  top: 40px;
  display: flex;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 4px 8px rgba(45, 54, 67, 0.05);
  border-radius: 8px;
  padding: 16px;
  flex-direction: column;
  > button:not(:last-child) {
    margin-bottom: 8px;
  }
  > button {
    width: 135px;
  }
`;
